import { PageContent } from './../models/models';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private dbPath = '/page-content';
  pageContentRef: AngularFirestoreCollection<PageContent> = null;

  constructor(private db: AngularFirestore) {
    this.pageContentRef = db.collection(this.dbPath);
  }

  //=================== Page Content =================================//
  getPC(): AngularFirestoreCollection<PageContent> {
    return this.pageContentRef;
  }

  updatePC(id: string, data: any): Promise<void> {
    return this.pageContentRef.doc(id).update(data);
  }
  //=================================================================//
}
